(function () {
  function syncComparisonSlider(root) {
    if (!root) return;

    var components = root.querySelectorAll('comparison-slider-component');

    components.forEach(function (component) {
      var slider = component.querySelector('.cs-slider');
      var mediaWrapper = component.querySelector('[data-comparison-slider]');

      if (!slider || !mediaWrapper) return;

      // Keep the native slider value as the source of truth.
      var value = slider.value || '50';

      // Remove transition during resize sync to avoid visual lag.
      mediaWrapper.style.setProperty('--transition-duration', '0s');

      // Use the native component sync method when available.
      if (typeof component.sync === 'function') {
        component.sync();
      } else {
        var min = Number(slider.min || 0);
        var max = Number(slider.max || 100);
        var val = (Number(value) - min) / (max - min);
        var compareValue = Math.round(val * 100);
        mediaWrapper.style.setProperty('--compare', String(compareValue));
      }

      // Also dispatch input as a fallback for the native on:input listener.
      slider.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function initComparisonMock(context) {
    var scope = context || document;
    var sections = [];

    if (scope.matches && scope.matches('.nc-comparison-mock')) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections = sections.concat(
        Array.prototype.slice.call(scope.querySelectorAll('.nc-comparison-mock'))
      );
    }

    sections.forEach(function (section) {
      syncComparisonSlider(section);
    });
  }

  var resizeTimer;

  function handleResize() {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      initComparisonMock(document);
    }, 160);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initComparisonMock(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initComparisonMock(event.target);
  });

  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
})();